<template>
  <button @click="onClickCancel" class="btn btn-outline border btn-sm">
    <slot></slot>
  </button>
</template>

<script>
export default {
  methods: {
    onClickCancel() {
      this.$emit('clicked');
    },
  },
};
</script>

<style lang="scss"></style>
